<template>
	<div class="table">
		<div class="table__title">
			{{ title }}
		</div>
		<DataTable dataKey="stock_id" :paginator="false" ref="dt" :rows="20" responsiveLayout="scroll" class="p-datatable-sm p-datatable-striped boxshadow" :value="stock_expired" showGridlines :filters.sync="filters" filterDisplay="row">
			<template #header>
				<div class="flex mx-4">
					<div v-if="checkPermission('purchase_write')">
						<Button type="button" icon="pi pi-file-excel" class="p-button-success p-button-outlined" @click="exportToExcel" />
					</div>
				</div>
			</template>
			<Column field="sapcode" header="SAP" key="sapcode" sortable>
				<template #body="{ data }"> {{ data.sapcode }} </template>
				<template #filter="{ filterModel, filterCallback }">
					<InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter" />
				</template>
			</Column>
			<Column field="champcode" header="Champ" key="champcode" sortable>
				<template #body="{ data }">
					{{ data.champcode }}
				</template>
				<template #filter="{ filterModel, filterCallback }">
					<InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter" />
				</template>
			</Column>
			<Column field="name" header="Name" key="name" sortable>
				<template #body="{ data }">
					{{ data.name }}
				</template>
				<template #filter="{ filterModel, filterCallback }">
					<InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter" />
				</template>
			</Column>

			<Column field="packaging" header="Packaging" key="packaging" sortable> </Column>
			<Column field="weight" header="Weight kg per package" key="weight" sortable>
				<template #body="{ data }">
					<div v-if="data.weight">{{ parseFloat(data.weight).toFixed(2) }} kg</div>
				</template>
			</Column>
			<Column v-if="checkPermission('stock_read')" field="date_expiration" header="Expired" sortable>
				<template #body="{ data }">
					<div v-if="data.date_expiration">
						{{ data.date_expiration | moment("DD MMMM YYYY") }}
					</div>
				</template>
			</Column>
			<Column v-if="checkPermission('stock_read')" field="stockSum" header="On stock" sortable>
				<template #body="{ data }">
					{{ data.stockSum }} (<span class="text-success">{{ data.stockValid }}</span> + <span class="text-danger">{{ data.stockExpired }}</span
					>)
				</template>
			</Column>

			<Column v-if="1 == 2 && checkPermission('stock_read')" field="stockExpired" header="Expired" sortable>
				<template #body="{ data }">
					{{ data.stockExpired }}
				</template>
			</Column>
			<Column v-if="checkPermission('stock_read')" field="quantity" header="Quantity" sortable>
				<template #body="{ data }">
					{{ data.quantity }}
				</template>
			</Column>

			<Column v-if="checkPermission('stock_read')" field="stock_min" header="Min stock" key="stock_min" sortable> </Column>
			<Column v-if="checkPermission('stock_read')" field="stock_max" header="Max stock" key="stock_max" sortable> </Column>
			<Column field="location" header="Location Warehouse" key="location" sortable>
				<template #body="{ data }">
					{{ data.location }}
				</template>
				<template #filter="{ filterModel, filterCallback }">
					<InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter" />
				</template>
			</Column>
			<Column field="supplier" header="Order from" key="orderfrom" sortable>
				<template #body="{ data }">
					<div v-if="suppliers.find((o) => o.id === data.supplier)">
						{{ suppliers.find((o) => o.id === data.supplier).code }}
					</div>
				</template>
			</Column>

			<Column field="Actions" header="Order from" key="actions" sortable>
				<template #body="{ data }">
					<Button type="button" label="Destroy" class="p-button-danger" v-tooltip.top="'Remove expired items from stock'" @click="destroyExpired(data)" :badge="String(data.quantity)" />
				</template>
			</Column>

			<template #footer>
				<div class="table__footer"><strong>For questions please contact:</strong> RDA Warehouse | <strong>E:</strong> <a href="mailto:SR0734@ppg.com"> SR0734@ppg.com</a> |<strong> P:</strong> +31 20 407 53 12</div>
			</template>
		</DataTable>
		<Toast />
		<ConfirmDialog></ConfirmDialog>
	</div>
</template>

<script>
import { directus } from "../store";
import { mapState } from "vuex";
import moment from "moment";

import { FilterMatchMode, FilterOperator } from "primevue/api/";

import * as XLSX from "xlsx";

export default {
	name: "rawmaterials",
	components: {},
	data() {
		return {
			title: "Expired materials",
			filters: {
				sapcode: {
					value: null,
					matchMode: FilterMatchMode.CONTAINS,
				},
				champcode: {
					value: null,
					matchMode: FilterMatchMode.CONTAINS,
				},
				name: {
					value: null,
					matchMode: FilterMatchMode.CONTAINS,
				},
				location: {
					value: null,
					matchMode: FilterMatchMode.CONTAINS,
				},
			},

			selectedMaterial: {
				name: "",
				sap: "",
				packaging: "",
				stock: [
					{
						quantity: 0,
					},
				],
			},
		};
	},
	created() {},
	async mounted() {
		await this.getData();
	},
	methods: {
		getData() {
			//console.log(this.$store);
			this.$store.dispatch("getData");
		},

		exportCSV() {
			this.$refs.dt.exportCSV();
		},

		exportToExcel() {
			let self = this;

			let excelData = [];

			if (self.stock_expired && self.stock_expired.length > 0) {
				let materials = self.stock_expired;
				materials.forEach((material) => {
					excelData.push({
						sap: material.sapcode,
						champ: material.champcode,
						description: material.name,
						packaging: material.packaging,
						weight: material.weight ? parseFloat(material.weight).toFixed(2) : null,
						date_expiration: material.date_expiration ? moment(material.date_expiration).format("DD MMMM YYYY") : null,
						stock: self.checkPermission("stock_read") ? material.stockSum : null,
						MinStock: self.checkPermission("stock_read") ? material.stock_min : null,
						MaxStock: self.checkPermission("stock_read") ? material.stock_max : null,
						location: material.location,
						supplier: material.supplier ? self.suppliers.find((o) => o.id === material.supplier).code : null,
					});
				});

				// Convert data to worksheet
				const worksheet = XLSX.utils.json_to_sheet(excelData);

				// Create a new workbook
				const workbook = XLSX.utils.book_new();

				// Append the worksheet to the workbook
				XLSX.utils.book_append_sheet(workbook, worksheet, "CriticalStock");

				// Generate an Excel file and trigger the download
				XLSX.writeFile(workbook, "CriticalStock.xlsx");
			}
		},
		async destroyExpired(data) {
			let stockID = data && data.stock_id ? data.stock_id : null;
			if (stockID) {
				await this.$confirm.require({
					message: "Are you sure you want to destroy?",
					header: "Destroy",
					icon: "pi pi-exclamation-triangle",
					accept: () => {
						this.$store.dispatch("destroyStock", { id: stockID });
						this.$toast.add({
							severity: "success",
							summary: "Stock",
							detail: "The stock is destroyed!",
							life: 3000,
						});
					},
					reject: () => {},
				});
			}
		},
	},
	computed: {
		...mapState({
			stock_expired: (state) => {
				let stock_expired = [];
				if (state.data.stock && state.data.stock && state.data.stock.length > 0) {
					for (let i = 0; i < state.data.stock.length; i++) {
						let rawmaterial_obj = _.find(JSON.parse(JSON.stringify(state.data.rawmaterials)), { id: state.data.stock[i].rawmaterial });
						if (rawmaterial_obj && rawmaterial_obj.expiration_days && state.data.stock[i].date_in) {
							let date_expiration = moment(state.data.stock[i].date_in).add(rawmaterial_obj.expiration_days, "days");
							rawmaterial_obj.stock = "xxx";

							if (moment(date_expiration).isBefore(moment()) && state.data.stock[i].status === "published" && rawmaterial_obj.stockExpired > 0) {
								console.log("rawmaterial_obj", rawmaterial_obj);
								stock_expired.push({
									isExpired: true,
									date_expiration: date_expiration.format("YYYY-MM-DD"),
									stock_id: state.data.stock[i].id,
									quantity: state.data.stock[i].quantity,
									rawmaterial_id: rawmaterial_obj.id,
									...rawmaterial_obj,
								});
							}
						}
					}
					console.log("stock", state.data.stock);
					console.log("stock_expired", stock_expired);
					return stock_expired;
				}
			},
			suppliers: (state) => state.data.suppliers,
		}),
	},
};
</script>

<style lang="scss">
.table {
	padding: 20px;
	&__title {
		color: #24222f;
		text-align: left;
		font-weight: bold;
		margin: 20px 0;
		font-size: 28px;
	}
	&__dialog {
		text-align: left;
	}
	&__footer {
		text-align: left;
	}
}

.text-success {
	color: #28a745;
}
.text-danger {
	color: #dc3545;
}
</style>
